import { render, staticRenderFns } from "./NewTemplate.vue?vue&type=template&id=302f2e80"
import script from "./NewTemplate.vue?vue&type=script&lang=ts"
export * from "./NewTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports